<strong class="period__heading" [style.left]="offsetPx" [class.orange]="altbar" [class.margin--bottom-m]="!altbar">{{ label }}</strong>
<div
  class="period__bar"
  [style.left]="offsetPx"
  [class.period__bar--alt]="altbar"
  [class.period__bar--no-date]="!serviceinterval?.startDate"
  >
  <span>{{ $safeNavigationMigration(serviceinterval?.startDate) | date: 'dd.MM.yyyy' }}</span>
  <div>
    @for (m of months; track m) {
      <span class="period__month period__month--solid" [class]="m.classes" [title]="getToolTip(m)"></span>
    }
    @for (o of onset; track o; let i = $index) {
      <span
        class="period__onset period__month--solid"
        [class]="o.classes"
        [class.period__onset--first]="i == 0"
        >
        @if (i == 0) {
          <strong>Slutter</strong>
        }
      </span>
    }
  </div>
  <span [class.red]="onset?.length > 0">{{ $safeNavigationMigration(serviceinterval?.endDate) | date: 'dd.MM.yyyy' }}</span>
</div>
